import { usePage } from "@inertiajs/react";

export const useMicromobilityContractorsURL = (): string => {
    return usePage<powerready.IPageProps>()?.props?.micromobility_contractors_url || "https://coned.com";
};
